export enum HostID {
    AB = 'ab',
    BI = 'bi',
    BR = 'br',
    MH = 'mh',
    RW = 'rw',
    VI = 'vi',
    VN = 'vn',
    VP = 'vp',
    VPBE = 'vpbe',
    WH = 'wh',
}
